import { ChangeDetectorRef, Component, ComponentFactoryResolver, ElementRef, OnInit, ViewChild,ViewContainerRef } from '@angular/core';
import { AspMyRequestService } from '../asp-my-request/asp-my-request.service';
import { AspInstantRequestComponent } from '../asp-instant-request/asp-instant-request.component';
import { AspClutchKitFlowService } from './asp-clutch-kit-flow.service';

export interface KitItem {
  id: string;
  title: string;
  desc: string;
  cardImg: string;
  heroImg: string;
  badgeType: 'blue' | 'orange' | 'green' | 'yellow'  | 'purple';
  badgeLabel: string;
  ctaLabel: string;
}
 

@Component({
  selector: 'app-asp-clutch-kit-flow',
  templateUrl: './asp-clutch-kit-flow.component.html',
  styleUrls: ['./asp-clutch-kit-flow.component.scss']
})
export class AspClutchKitFlowComponent implements OnInit {
  // ── existing props ────────────────────────────────────────
  insurance: any;
  isInsurance: boolean;
  openEdit: boolean;
  openEditIndex: number | null = null;
  selectedType: string;
  showError: boolean;
  selectedCompany: string;
  filteredList: string[];
  showError1: boolean;
  defaultImage: string = 'assets/images/logos/logo.png';
  defaultHeroImage: string = 'assets/images/logos/logo.png';
  @ViewChild('intstantorder', { read: ViewContainerRef }) containers!: ViewContainerRef;
  @ViewChild('kitScroll') kitScrollRef!: ElementRef<HTMLDivElement>;
  @ViewChild('multipleKitsSection') multipleKitsSection!: ElementRef;
  // ── kit props ─────────────────────────────────────────────
  showMultiKit = true;
  isAtStart = true;
  isAtEnd = false;
  activeDotIndex = 0;
  readonly VISIBLE_COUNT = 3;
  kits: any[] = [];
  selectedKit: any = {};
  allKitsData: any = {};
  includedIcons: any[] = [];
  kitBrands: string[] = [];

  constructor(
    private aspMyRequestService: AspMyRequestService,
    private resolver: ComponentFactoryResolver,
    private aspClutchKitFlowService: AspClutchKitFlowService,
    private cdr: ChangeDetectorRef,
  ) { }

  ngOnInit(): void {
     this.loadKits();
  }
  loadrequest() {
    localStorage.setItem('selectedKitName', this.selectedKit?.kitName || '');
    // ✅ Grab the "front" image for this kit and store it too
    const frontImage = this.selectedKit?.items?.find((x: any) => x.type === 'front')?.imageUrl
      || this.selectedKit?.banner?.imageUrl
      || '';

    localStorage.setItem('kitDefaultImage', frontImage);
    this.openInstantSidebar();
  }
    getInsurance() {
    this.aspMyRequestService.getInsurance().subscribe(result => {

      this.insurance = result['data'] || [];

      // ✅ ALWAYS re-trigger open after API completes
      this.loadrequest();

    });
  }
  toggleEditMenu(index: number, event: Event) {
    event.stopPropagation();
    this.openEditIndex = this.openEditIndex === index ? null : index;
  }
  skip() {
    this.isInsurance = false;
    this.openEdit = false;
    localStorage.removeItem("isInsurance");
    localStorage.removeItem('insuranceGarageKey');
    this.openInstantSidebar();  // ✅ Direct open
  }
  continue(): void {

    if (!this.selectedType) {
      this.showError = true;
      return;
    }

    if (this.selectedType === 'insurance' && !this.selectedCompany) {
      this.showError1 = true;
      return;
    }

    this.isInsurance = false;

    const type = this.selectedType === 'insurance';
    localStorage.setItem("isInsurance", String(type));
    localStorage.setItem('insuranceGarageKey', this.selectedCompany);

    this.openInstantSidebar();
  }
  openInstantSidebar() {
    // localStorage.setItem('clutchFlow', '1');
    if (!this.containers) {
      console.error('❌ Container not found');
      return;
    }

    this.containers.clear();

    const factory = this.resolver.resolveComponentFactory(AspInstantRequestComponent);
    const componentRef = this.containers.createComponent(factory);

    const instance = componentRef.instance as AspInstantRequestComponent;

    // ✅ ADD THIS LINE
    instance.fromClutchFlow = true;

    console.log('✅ Component created:', componentRef);

    if (localStorage.getItem('instantOrder') === '2') {
      instance.closeDetails(true);
      instance.openSidebar(true);
    } else {
      instance.closeDetails(false);
      instance.openSidebar(true);
      localStorage.removeItem('carNumber');
    }
  }
  // ── kit methods ───────────────────────────────────────────
  // selectKit(kit: any): void {

  //   this.selectedKit = kit;

  //   const kitData = this.allKitsData[
  //     kit.kitName.toLowerCase()
  //   ];

  //   if (!kitData) return;

  //   this.selectedKit.banner = kitData.find(
  //     x => x.type === 'banner'
  //   );

  //   this.includedIcons = kitData.filter(
  //     x => x.type === 'icon'
  //   );
  // }
  selectKit(kit: any): void {

    this.selectedKit = kit;

    const key = kit.kitName;

    const kitInfo = this.allKitsData[key];

    const items = kitInfo?.items || [];

    this.kitBrands = kitInfo?.brands || [];

    this.selectedKit.banner =
      items.find(x => x.type === 'banner');

    this.includedIcons =
      items.filter(x => x.type === 'icon');
  }

  isActive(kit: any): boolean {
    return this.selectedKit?.id === kit?.id;
  }
  get scrollDots(): number[] {
    // total dots = total cards - visible + 1
    const total = this.kits.length - this.VISIBLE_COUNT + 1;
    return Array.from({ length: total }, (_, i) => i);
  }

  scrollKits(direction: 1 | -1): void {
  const el = this.kitScrollRef?.nativeElement;
  if (!el) return;
  el.scrollBy({ left: direction * el.clientWidth, behavior: 'smooth' });
  setTimeout(() => {
    this.onKitScroll();
    this.cdr.detectChanges(); // ← force Angular to pick up changes
  }, 350);
}

  onKitScroll(): void {
  const el = this.kitScrollRef?.nativeElement;
  if (!el) return;
  const { scrollLeft, scrollWidth, clientWidth } = el;
  this.isAtStart = scrollLeft <= 2;
  this.isAtEnd = scrollLeft + clientWidth >= scrollWidth - 2;
  const cardWidth = scrollWidth / this.kits.length;
  this.activeDotIndex = Math.round(scrollLeft / cardWidth);
}

  scrollToDot(index: number): void {
    const el = this.kitScrollRef?.nativeElement;
    if (!el) return;
    const cardWidth = el.scrollWidth / this.kits.length;
    el.scrollTo({ left: index * (cardWidth + 12), behavior: 'smooth' });
  }

  ngAfterViewInit(): void {
  // defer so kits data is ready and no ExpressionChanged error
  setTimeout(() => {
    this.onKitScroll();
    this.cdr.detectChanges();
  }, 300);
}
  loadKits(): void {
    this.aspClutchKitFlowService.getAllKits().subscribe(
      (response: any) => {

        this.allKitsData = response.data || {};

        this.kits = Object.keys(this.allKitsData)
          .map(key => {

            const items = this.allKitsData[key]?.items || [];
            const front = items.find( item => item.type === 'front');

            if (front) {

            switch (front.kitName?.toLowerCase()) {

              case 'clutch kit':
                front.badgeType = 'blue';
                break;

              case 'filter kit':
                front.badgeType = 'orange';
                break;

              case 'brake kit':
                front.badgeType = 'green';
                break;

              default:
                front.badgeType = 'blue';
            }
          }

          return front;

          })
          .filter(item => item);

        if (this.kits.length > 0) {
          this.selectKit(this.kits[0]);
        }

        console.log('kits', this.kits);
      },
      error => console.error(error)
    );
  }
  // ==defualu image===================
  onKitImageError(event: any) {
    event.target.src = this.defaultImage;
    event.target.onerror = null;
  }
  // ===============scroll to multiple kits section===========
  scrollToIncluded() {
    this.multipleKitsSection?.nativeElement.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }
  get repeatedBrands(): string[] {
    return Array(6)
      .fill(this.kitBrands)
      .flat();
  }
  getDisplayTag(tag: string): string {
    if (!tag) return '';

    return tag.replace(/U\+([0-9A-Fa-f]+)/g, (_, hex) =>
      String.fromCodePoint(parseInt(hex, 16))
    );
  }
}
